import './App.css';

import Navbar from './components/Navbar';
import FooterNew from './components/FooterNew';

import FAQ from './components/FAQ';
import Financing from './components/Financing';
import Benefits from './components/Benefits';
import FloatingSidebar from './components/FloatingSidebar';
import Results from './components/Results';

function App() {
	return (
		<div className='App'>
			<Navbar />
			{/* <FloatingSidebar /> */}
			<Results />
			<Benefits />
			<Financing />
			<FAQ />
			<FooterNew />
		</div>
	);
}

export default App;
